import axios from "axios";
import { SET_BREADCRUMB } from "@/core/services/store/breadcrumbs.module";
import colorPicker from "@caohenghu/vue-colorpicker";

export default {
  name: "profiles",
  components: {
    colorPicker
  },
  props: [],
  data() {
    return {
      toCreate: {},
      toEdit: {},
      selectedItem: {},
      creating: true,
      fields: [
        "name",
        "image",
        "color",
        "description",
        {
          key: "actions",
          label: "Actions"
        }
      ]
    };
  },
  computed: {
    profiles() {
      return this.$store.getters.getProfiles;
    }
  },

  mounted() {
    this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Backend" },
      { title: "Users", route: "students" },
      { title: "Manage Profiles" }
    ]);
  },

  methods: {
    changeColor(color) {
      const { r, g, b, a } = color.rgba;
      if (this.creating == true) {
        this.toCreate.color = `rgba(${r}, ${g}, ${b}, ${a})`;
      } else {
        this.toEdit.color = `rgba(${r}, ${g}, ${b}, ${a})`;
      }
    },
    openSucker(isOpen) {
      if (isOpen) {
        // ... canvas be created
        // this.suckerCanvas = canvas
        // this.suckerArea = [x1, y1, x2, y2]
      } else {
        // this.suckerCanvas && this.suckerCanvas.remove
      }
    },
    createItem(evt) {
      evt.preventDefault();
      axios.post("profiles", this.toCreate).then(response => {
        console.log(response);
        this.$store.dispatch("fetchProfiles");
        this.toCreate = {};
      });
    },
    deleteItem(id) {
      axios.delete("profiles/" + id).then(response => {
        console.log(response);
        this.$store.dispatch("fetchProfiles");
      });
    },
    editItem(id, evt) {
      evt.preventDefault();
      axios.put("profiles/" + id, this.toEdit).then(response => {
        console.log(response);
        this.$store.dispatch("fetchProfiles");
      });
      this.creating = true;
    },
    viewItem(item) {
      this.toEdit = item;
      this.creating = false;
    },
    changeToCreate() {
      this.toEdit = null;
      this.creating = true;
    }
  }
};
